import { ZINDEX as n } from "../constants/z-index.js";
function r() {
  return n;
}
export {
  r as getZIndexConfig
};
//# sourceMappingURL=z-index.js.map
